export default function SectionHeading({ eyebrow, title, sub, align = "left", invert = false }) {
  const textColor = invert ? "text-white" : "text-[#1A1A1A]";
  const subColor = invert ? "text-[#9CA3AF]" : "text-[#4B5563]";
  return (
    <div className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl`}>
      {eyebrow && (
        <div className={`flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}>
          <span className="divider-gold"></span>
          <span className="tracking-eyebrow text-[#D4AF37]">{eyebrow}</span>
        </div>
      )}
      <h2 className={`font-display ${textColor} mt-5 text-3xl sm:text-4xl md:text-5xl tracking-tight leading-[1.05]`}>{title}</h2>
      {sub && <p className={`mt-5 text-base leading-relaxed ${subColor}`}>{sub}</p>}
    </div>
  );
}
